import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json'
import * as rules from 'vee-validate/dist/rules'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import axiosIns, { refreshSession } from './libs/axiosIns'

axiosIns.interceptors.response.use(
  response => response,
  async error => {
    const requestUrl = error.config?.url || ''
    const isAuthenticationFlow = /(?:^|\/)Auth\/(Login|VerifyMfa|ResendMfa|ActivateAccount|Refresh|Csrf)$/i.test(requestUrl)
    const requestConfig = error.config

    if (error.response?.status === 401
      && !isAuthenticationFlow
      && requestConfig
      && !requestConfig.refreshAttempt
      && requestConfig.headers?.['X-Session-Mode'] === 'cookie') {
      requestConfig.refreshAttempt = true

      try {
        await refreshSession()
        return axiosIns(requestConfig)
      } catch (refreshError) {
        store.dispatch('auth/resetSession')
        router.push({ name: 'login' }).catch(() => {})
        return Promise.reject(refreshError)
      }
    }

    if (error.response?.status === 401 && !isAuthenticationFlow) {
      store.dispatch('auth/resetSession')
      router.push({ name: 'login' }).catch(() => {})
    }

    return Promise.reject(error)
  },
)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// VeeValidate
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
localize('fr', fr)
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
